import { render, staticRenderFns } from "./Footbar.vue?vue&type=template&id=0958f2f4"
import script from "./Footbar.vue?vue&type=script&lang=js"
export * from "./Footbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports